import React, { useCallback, useEffect, useState } from 'react';
import Header from './Header';
import { useSelector } from 'react-redux';
import {
  Wrap,
  Content,
  Title,
  Button,
  IconBarCode,
  Text,
  IconPhone,
  Address,
  Container,
  BottonLogo,
  IconNumberBarCode,
  IconWhatsapp,
  Img,
} from './styles';
import { useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import Toast from '../../components/Toast';
import AuthGenerateBillet from '../AuthGenerateBillet';

const GenerateBillet: React.FC = () => {
  const location = useLocation();
  const state = location.state as { billet: string };

  const { billet } = state;
  const config = useSelector((state: ApplicationState) => state.config);
  const { billetId } = useParams<{
    billetId: string;
  }>();
  const databaseId = billetId.substring(billetId.length - 2);

  const [pdfUrl, setPdfUrl] = useState<string>();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(false);
  const copyToClipboard = (text: string) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    toast.error(
      <Toast
        title={'Aviso'}
        type={'success'}
        description={'Copiado para Área de Transferência'}
      />
    );
  };

  const toWhatsappContact = useCallback(() => {
    const { whatsappContact, whatsappMessage } = config;
    const formattedWpp = whatsappContact.replace(/[()\-+ ]/g, '');
    const formattedWppMessage = whatsappMessage
      .replace(/#/g, '%23')
      .replace(/&/g, '%26');

    if (formattedWpp)
      window.open(
        `https://wa.me/55${formattedWpp}?text=${formattedWppMessage}`
      );
  }, [config]);

  useEffect(() => {
    const fetchPdf = async () => {
      const { data } = await api.getBillet({
        id: billet,
        databaseId: Number(databaseId),
      });
      if (!data) return;

      const linkSource = `data:application/pdf;base64,${data}`;
      setPdfUrl(linkSource);
    };
    fetchPdf();
  }, [databaseId, billet]);

  const getSerialNumber = useCallback(async () => {
    const { data } = await api.rpaGetLinhaDigBillet({
      id: billet,
      databaseId: Number(databaseId),
    });
    copyToClipboard(data ?? '');
  }, [databaseId, billet]);

  return (
    <Wrap>
      <Header />

      <Content auth={isAuthenticated}>
        <Title auth={isAuthenticated}>É bom ter você aqui :)</Title>
        <Text auth={isAuthenticated}>
          Aqui você pode acessar a 2ª via do seu boleto.{' '}
          {isAuthenticated
            ? 'Se precisar, fale conosco através dos canais abaixo.'
            : ''}
        </Text>

        {isAuthenticated ? (
          <>
            <Button>
              <a href={pdfUrl} download={'Boleto'}>
                <IconBarCode />
                Baixe seu boleto
              </a>
            </Button>
            <Button
              onClick={() => {
                copyToClipboard(config.assessoriaTelephone.replace(/\D/g, ''));
              }}
            >
              <IconPhone />
              <a href={`tel:${config.assessoriaTelephone.replace(/\D/g, '')}`}>
                Ligar grátis para 0800
              </a>
            </Button>
            <Button
              onClick={() => {
                toWhatsappContact();
              }}
            >
              <IconWhatsapp />
              Fale conosco
            </Button>
            <Button
              onClick={() => {
                getSerialNumber();
              }}
            >
              <IconNumberBarCode>
                24300 <br />
                00342
              </IconNumberBarCode>
              Copiar código de barras
            </Button>
          </>
        ) : (
          <AuthGenerateBillet
            id={billetId}
            databaseId={databaseId}
            setIsAuthenticated={setIsAuthenticated}
          />
        )}
      </Content>

      <BottonLogo>
        <Img src={config.assessoriaImage} />
      </BottonLogo>
      <Container>
        <Address>{config.enderecoAssessoria}</Address>
      </Container>
    </Wrap>
  );
};

export default GenerateBillet;
